/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Save_SuccessInputs */

const en_admin_settings_save_success = /** @type {(inputs: Admin_Settings_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings saved`)
};

const zh_admin_settings_save_success = /** @type {(inputs: Admin_Settings_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置已保存`)
};

/**
* | output |
* | --- |
* | "Settings saved" |
*
* @param {Admin_Settings_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_save_success = /** @type {((inputs?: Admin_Settings_Save_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Save_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_save_success(inputs)
	return zh_admin_settings_save_success(inputs)
});
export { admin_settings_save_success as "admin.settings.save_success" }